/* eslint-disable react-hooks/set-state-in-effect */
import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const InventoryContext = createContext({ inventory: {}, refresh: () => {} });

export function InventoryProvider({ children }) {
  const [inventory, setInventory] = useState({});

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/inventory`);
      setInventory(data || {});
    } catch (err) {
      // silent — show "—" badges if API down
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 30000); // soft poll every 30s
    return () => clearInterval(id);
  }, [refresh]);

  return (
    <InventoryContext.Provider value={{ inventory, refresh }}>
      {children}
    </InventoryContext.Provider>
  );
}

export function useInventory() {
  return useContext(InventoryContext);
}

// Helper: returns { stock, initial_stock, isLow, isOut, percentLeft } for a given slug
export function useProductStock(slug) {
  const { inventory } = useInventory();
  const entry = inventory[slug];
  if (!entry) {
    return { stock: null, initial_stock: null, isLow: false, isOut: false, percentLeft: null, known: false };
  }
  const stock = entry.stock ?? 0;
  const initial = entry.initial_stock || 100;
  return {
    stock,
    initial_stock: initial,
    isLow: stock > 0 && stock <= 10,
    isOut: stock <= 0,
    percentLeft: initial > 0 ? Math.round((stock / initial) * 100) : 0,
    known: true,
  };
}
